module.exports = __webpack_public_path__ + "img/2024-10-16f_4.f2e5d74d.jpg";